import React, { useState } from 'react';
import CasinoContainer from '../../../../components/casino/CasinoContainer';
import CasinoInfoContent from '../../../../components/casino/properties/CasinoInfoContent';
import { API_CASINO } from '../../../../api/casino';
import useToast from '../../../../hooks/useToast';
import { useNavigate } from 'react-router';
import { dispatchCusEvent } from '../../../../utils';
import { ENUM_CUS_EVENT } from '../../../../enums/enums';

export default function CreateCasinos() {
  const { successToast } = useToast();
  const navigate = useNavigate();

  const onCreateCasino = (data) => {
    API_CASINO.create(data)
      .then((e) => {
        successToast('Casino successfully created');
        const id = e.data || '';
        const link = '/settings/casino/' + id;

        dispatchCusEvent(ENUM_CUS_EVENT.getCasinos);
        navigate(link);
      })
      .catch(console.error);
  };

  return (
    <CasinoContainer hideMenu title={'Create casino'}>
      <CasinoInfoContent onSaveClick={onCreateCasino} />
    </CasinoContainer>
  );
}
